<script setup>
import {ref} from "vue";

const props = defineProps({
  terminateAt: {
    type: [String, null],
    required: false,
    default: null,
  },
  organisationId: {
    type: Number,
    required: true,
  },
});

const localDate = ref(props.terminateAt ?? "");

const success = (event) => {
  localDate.value = event;
};
</script>

<template>
  <EditInput
    type="date"
    :url="`/admin/crm/organisations/${organisationId}/update-terminate-date`"
    :current-value="localDate"
    @success="success"
  >
    <span>
      {{ localDate }}
    </span>
  </EditInput>
</template>

